import DropDown from './dropdown/dropdown';
import Orders from './orders/orders';
import OrderTable from './orders/order-table';
import NewOrder from './orders/new-order';
import Alerts from './alerts/alerts';
import Datepicker from './datepicker/datepicker';
import DentistTable from './dentists/dentist-table';
import DentistOrderTable from './dentists/dentist-orders-table';
import DentistInvoiceTable from './dentists/dentist-invoices-table';
import DentistAllOrderTable from './dentists/dentist-all-orders-table';
import DentistAllInvoiceTable from './dentists/dentist-all-invoices-table';

export default function () {

    //new Orders($("[data-orders]"));
    //new OrderDetails($("[data-order-details]"));

    window.rowAttribute = function (row, index) {
        var rowId = Number(row.id);
        return {
            class: 'bs-row-' + rowId,
            data_id: rowId,
            'data-uniqueid': rowId
        };
    }

    $('[data-orders]').each(function (index, value) {
        new Orders($(value));
    });

    $('[data-order-table]').each(function (index, value) {
        new OrderTable($(value));
    });

    $('[data-alert]').each(function (index, value) {
        new Alerts($(value));
    });

    $(".cs-dropdown").each(function (index) {
        new DropDown($(this));
    });

    $('[data-new-order]').each(function (index, value) {
        new NewOrder($(value));
    });

    $("[date-picker]").each(function (index, element) {
        new Datepicker($(this), index);
    });

    $("#dentist-save").on('click', function () {
        $("#dentist-form").submit();
    });

    $("[data-dentist-table]").each(function (index, value) {
        new DentistTable($(value));
    });

    $("[data-dentist-order-table]").each(function (index, value) {
        new DentistOrderTable($(value));
    });


    $("[data-dentist-invoice-table]").each(function (index, value) {
        new DentistInvoiceTable($(value));
    });

    $("[data-dentist-detail-all-table]").each(function (index, value) {
        new DentistAllOrderTable($(value));
    });

    $("[data-dentist-detail-invoice-table]").each(function (index, value) {
        new DentistAllInvoiceTable($(value));
    });

    //Order status field
    $("#status-field, .modal-order-status, #all-status-field").select2({minimumResultsForSearch: -1, dropdownParent: $('#content')}
    );
    //$("#at-qty").select2({minimumResultsForSearch: -1, dropdownParent: $('#content')});
    $(".tooth-color").select2({minimumResultsForSearch: -1, dropdownParent: $('.choose-color-holder')});

    $(".tooth-color").each(function (index, value) {
        if (typeof $(this).data('selected-opt') != 'undefined') {
            $(this).val($(this).data('selected-opt')).trigger('change');
        } else {
            $(this).val($(this).first().val()).trigger('change');
        }
    });
    
    $(".dentists-order-list").select2({
        ajax: {
            url: "/dentist-list",
            dataType: 'json',
            data: function (params) {
                return {
                    q: params.term, // search term
                    page: params.page
                };
            },
            processResults: function (data, params) {
                // parse the results into the format expected by Select2
                // since we are using custom formatting functions we do not need to
                // alter the remote JSON data, except to indicate that infinite
                // scrolling can be used
                params.page = params.page || 1;
                return {
                    results: data.items,
                    pagination: {
                        more: (params.page * 10) < data.total_count
                    }
                };
            },
            cache: true
        },
        placeholder: 'Select Dentist',
        escapeMarkup: function (markup) {
            return markup;
        },
        dropdownParent: $('#content'),
    });

    if ($('#content .select2-container')) {
        $('#content .select2-container').addClass('flex-1');
    }
    
    //Hide show Password for dentist
    $(".hide-password").on('click', function () {
        $('#password-field').attr('type', "text");
        $('.view-password').show();
        $(this).hide();
    });
    $(".view-password").on('click', function () {
        $('#password-field').attr('type', "password");
        $('.hide-password').show();
        $(this).hide();
    });

    $('form').attr('autocomplete', 'off');
}


